import e from "./index.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const o = i(e);
export {
  o as initFilePreview
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/file-preview/index.js
// module id = 1286
// module chunks = 67